import { Field } from 'formik';
import React from 'react';
import { Fieldset, Input } from '@fourthwall/components';
export const RangeForm = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "label", component: Input, label: "Label", placeholder: "Setting label" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "default", component: Input, label: "Default Value (optional)", placeholder: "Default value" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "min", component: Input, label: "Minimum Value", type: "number" })),
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "max", component: Input, label: "Maximum Value", type: "number" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "step", component: Input, label: "Step", type: "number" })),
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "unit", component: Input, label: "Unit (optional)", placeholder: "px, %, etc." })))));
};
